import React from 'react'
import { Tooltip } from 'antd'
import { FloatButton } from 'antd5'
import styles from './index.less'
import { isNewLayout } from '@/utils/utils'

export const copyPolyfill = (text: string) => {
  const input = document.createElement('input')
  document.body.appendChild(input)
  input.style.position = 'fixed'
  input.style.opacity = '0'
  input.setAttribute('readonly', 'readonly')
  input.setAttribute('value', text)
  document.body.appendChild(input)
  input.select()
  document.execCommand('copy')
  document.body.removeChild(input)
}

const HelpCenter = () => {
  const clickHandler = () => {
    window.open('https://xiaoduoai.feishu.cn/wiki/wikcnVQNCbrBJ05dCGzCwFvknwg')
  }

  return isNewLayout ? (
    <FloatButton
      onClick={clickHandler}
      tooltip={{
        placement: 'left',
        title: '帮助中心',
      }}
      icon={<i className="iconfont icon-icon-help" />}
    />
  ) : (
    <Tooltip title="帮助中心">
      <div className={styles.guide} onClick={clickHandler}>
        <i className={`iconfont icon-icon-help ${styles.guideIcon}`} />
      </div>
    </Tooltip>
  )
}

export default HelpCenter
